var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyesLookingLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 39,
    viewBox: "0 0 49 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0574 19.3106C23.0574 29.9756 17.8959 38.6212 11.5287 38.6212C5.16159 38.6212 0 29.9756 0 19.3106C0 8.64566 5.16159 0 11.5287 0C17.8959 0 23.0574 8.64566 23.0574 19.3106Z",
    fill: "url(#paint0_radial_2416_28929)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.571779 20.4637C0.571779 16.1659 3.66873 12.6818 7.48902 12.6818C11.3093 12.6818 14.4063 16.1659 14.4063 20.4637C14.4063 24.7615 11.3093 28.2456 7.48901 28.2456C3.66873 28.2456 0.571779 24.7615 0.571779 20.4637Z",
    fill: "url(#paint1_linear_2416_28929)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5274 20.4638C11.5274 23.1698 9.46279 25.3635 6.91593 25.3635C4.36908 25.3635 2.30444 23.1698 2.30444 20.4638C2.30444 17.7578 4.36908 15.5641 6.91593 15.5641C9.46279 15.5641 11.5274 17.7578 11.5274 20.4638Z",
    fill: "#262626"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.48902 14.0817C4.59234 14.0817 1.9717 16.7795 1.9717 20.4637C1.9717 24.1479 4.59234 26.8457 7.48901 26.8457C10.3857 26.8457 13.0063 24.1479 13.0063 20.4637C13.0063 16.7795 10.3857 14.0817 7.48902 14.0817ZM7.48902 12.6818C3.66873 12.6818 0.571779 16.1659 0.571779 20.4637C0.571779 24.7615 3.66873 28.2456 7.48901 28.2456C11.3093 28.2456 14.4063 24.7615 14.4063 20.4637C14.4063 16.1659 11.3093 12.6818 7.48902 12.6818Z",
    fill: "url(#paint3_linear_2416_28929)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83971 18.2753C5.37628 19.2612 4.36118 19.7599 3.57242 19.3892C2.78367 19.0184 2.51995 17.9186 2.98338 16.9327C3.44682 15.9467 4.46192 15.448 5.25068 15.8188C6.03943 16.1895 6.30315 17.2893 5.83971 18.2753Z",
    fill: "#FBF2C3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9986 19.3106C48.9986 29.9756 43.837 38.6212 37.4699 38.6212C31.1027 38.6212 25.9412 29.9756 25.9412 19.3106C25.9412 8.64566 31.1027 0 37.4699 0C43.837 0 48.9986 8.64566 48.9986 19.3106Z",
    fill: "url(#paint3_radial_2416_28929)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5127 20.4637C26.5127 16.1659 29.6096 12.6818 33.4299 12.6818C37.2502 12.6818 40.3472 16.1659 40.3472 20.4637C40.3472 24.7615 37.2502 28.2456 33.4299 28.2456C29.6096 28.2456 26.5127 24.7615 26.5127 20.4637Z",
    fill: "url(#paint4_linear_2416_28929)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4299 14.0817C30.5333 14.0817 27.9126 16.7795 27.9126 20.4637C27.9126 24.1479 30.5333 26.8457 33.4299 26.8457C36.3266 26.8457 38.9473 24.1479 38.9473 20.4637C38.9473 16.7795 36.3266 14.0817 33.4299 14.0817ZM33.4299 12.6818C29.6096 12.6818 26.5127 16.1659 26.5127 20.4637C26.5127 24.7615 29.6096 28.2456 33.4299 28.2456C37.2502 28.2456 40.3472 24.7615 40.3472 20.4637C40.3472 16.1659 37.2502 12.6818 33.4299 12.6818Z",
    fill: "url(#paint4_linear_2416_28929)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4683 20.4638C37.4683 23.1698 35.4037 25.3635 32.8569 25.3635C30.31 25.3635 28.2454 23.1698 28.2454 20.4638C28.2454 17.7578 30.31 15.5641 32.8569 15.5641C35.4037 15.5641 37.4683 17.7578 37.4683 20.4638Z",
    fill: "#262626"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7806 18.2753C31.3172 19.2612 30.3021 19.7599 29.5133 19.3892C28.7246 19.0184 28.4609 17.9186 28.9243 16.9327C29.3877 15.9467 30.4028 15.448 31.1916 15.8188C31.9803 16.1895 32.2441 17.2893 31.7806 18.2753Z",
    fill: "#FBF2C3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2416_28929",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.5287 19.3106) rotate(90) scale(19.3106 11.5287)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.833333,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCA2F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2416_28929",
    x1: 7.48901,
    y1: 28.2456,
    x2: 7.48902,
    y2: 12.6818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2416_28929",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.4699 19.3106) rotate(90) scale(19.3106 11.5287)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.833333,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCA2F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2416_28929",
    x1: 33.4299,
    y1: 28.2456,
    x2: 33.4299,
    y2: 12.6818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyesLookingLeft);
export default __webpack_public_path__ + "static/media/eyes_looking_left.c8e618df5cbc480829888ce937db194e.svg";
export { ForwardRef as ReactComponent };